import ErrorBoundary from './ErrorBoundary';
import { useNavigate } from 'react-router-dom';

/**
 * Route-level Error Boundary
 * Wraps entire routes to catch navigation and rendering errors
 */
const RouteErrorBoundary = ({ children, routeName }) => {
  const navigate = useNavigate();

  const handleReset = () => {
    // Navigate to dashboard on reset
    navigate('/dashboard', { replace: true });
  };

  return (
    <ErrorBoundary
      name={`route-${routeName || 'unknown'}`}
      fallbackTitle="Page Load Error"
      fallbackMessage={`Unable to load the ${routeName || 'requested'} page. This might be due to a network issue or a temporary problem.`}
      onReset={handleReset}
      showReset={true}
      showHome={true}
      showFeedback={true}
      level="error"
    >
      {children}
    </ErrorBoundary>
  );
};

export default RouteErrorBoundary;
